import React, { useMemo } from 'react';
import { searchValueInText, mergeSpeakers, useCurrentItemIndex } from '../../utils';
import TranscriptItem from '../TranscriptItem';
import PlaceholderEmpty from '../PlaceholderEmpty';
import OPTIONS from '../ViewsSelector/options';

const option = OPTIONS.find((o) => o.value === 'transcript') || {};
const ENTITY = option.text || 'Transcript';
const ICON = option.icon;

const Transcript = ({
  transcript,
  searchValue,
  currentTime,
  setVideoPlayerCurrentTime,
  assetId,
  revisionId,
  manageTranscriptPermission,
  transcribing,
  isReaderView,
}) => {
  const items = useMemo(() => {
    const baseData = isReaderView ? mergeSpeakers(transcript) : transcript;
    let lastSpeaker = null;

    return baseData.map((item) => {
      const isNewSpeaker = lastSpeaker !== item.speaker;
      lastSpeaker = item.speaker;

      const text = searchValueInText(item.text, searchValue);

      if (Array.isArray(text) && text.length <= 1) return null;

      return {
        start: item.start,
        end: item.end,
        text,
        speaker: item.speaker,
        isNewSpeaker,
      };
    }).filter(Boolean);
  }, [isReaderView, searchValue, transcript]);

  const [activeItemIndex, setTime] = useCurrentItemIndex(items, currentTime, setVideoPlayerCurrentTime, 'start', 'end');

  if (!items.length) return <PlaceholderEmpty entity={ENTITY} icon={ICON} isSearch={!!searchValue} />;

  return items
    .map(({
      start, speaker, text, isNewSpeaker,
    }, i) => (
      <TranscriptItem
        key={start + text}
        isActive={activeItemIndex === i}
        setVideoPlayerCurrentTime={setTime}
        startTime={start}
        text={text}
        speaker={speaker}
        assetId={assetId}
        activeRevisionID={revisionId}
        manageTranscriptPermission={manageTranscriptPermission}
        transcribing={transcribing}
        isNewSpeaker={isNewSpeaker}
        isReaderView={isReaderView}
      />
    ));
};

export default Transcript;
